import { initEmploymentForm } from "@/assets/variables";

import node from "./employment-form-node.store";
import page from "./employment-form-page.store";
import tool from "./employment-form-tool.store";

/** @type {import("vuex/types/index.d.ts").Module} */
export const form = {
    namespaced: true,

    state: {
        form: initEmploymentForm(),
        loading: false,
    },

    mutations: {
        setForm(state, form) {
            state.form = initEmploymentForm(form);
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },

    actions: {
        reset(store) {
            store.commit("setForm");
            store.dispatch("node/reset");
            store.dispatch("page/reset");
            store.dispatch("tool/reset");
        },
    },

    modules: {
        node,
        page,
        tool,
    },
};

export default form;
